<p #descriptionText class="text-(color:--text-secondary) max-w-prose" [class.line-clamp-3]="!expanded()">
  {{ description() }}
</p>
@if (isOverflowing() || expanded()) {
  <button
    type="button"
    class="text-xs font-semibold hover:underline mt-(--space-1) cursor-pointer"
    [attr.aria-expanded]="expanded()"
    (click)="expanded.set(!expanded())">
    {{ (expanded() ? 'common.buttons.showLess' : 'common.buttons.showMore') | transloco }}
  </button>
}
